if (!customElements.get('add-to-cart-popup')) {
  class AddToCartPopup extends HTMLElement {
    constructor() {
      super();

      this.previousItems = [];
      this.cookieName = 'hypertheme:addtocart-popup';
    }

    connectedCallback() {
      this.modal = this.querySelector('#modal');
      this.modalText = this.querySelector('#modal-text');
      this.closeBtn = this.querySelector('#close-btn');

      // Bind close button if exists
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.hide());
      }

      // Subscribe to cart updates
      this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
        FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
        this.onCartUpdated.bind(this)
      );
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }

      // Clean up close button event listener
      if (this.closeBtn) {
        this.closeBtn.removeEventListener('click', () => this.hide());
      }
    }

    onCartUpdated(event) {
      if (this.shouldShowModal(event)) {
        const newItem = event.cart.items[0];

        this.show(newItem.product_title);
        this.setRepeatOpen();
      }
    }

    show(productName) {
        if (!this.modal || !this.modalText) return;

        this.modalText.textContent = `${productName} added to cart!`;

        // Ensure it's visible
        this.modal.removeAttribute('hidden');

        // Auto-hide after 5 seconds
        clearTimeout(this._hideTimeout);
        this._hideTimeout = setTimeout(() => this.hide(), 5000);
    }

    hide() {
        if (!this.modal) return;

        this.modal.setAttribute('hidden', '');

        clearTimeout(this._hideTimeout);
        this._hideTimeout = null;
    }


    shouldShowModal(event) {
      // There is no event - don't show
      if (!event) {
        return false
      }

      // The cart is empty - don't show
      if (!event.cart?.items?.length) {
        return false;
      }

      // The event has a name, so its inorganic - don't show
      if (event.hasOwnProperty('name')) {
        return false;
      }

      // Show the modal
      return true;
    }

    setRepeatOpen() {
      const expires = 1; // 1 day
      FoxTheme.utils.setStorage(this.cookieName, { opened: true }, expires);
    }
  }

  customElements.define('add-to-cart-popup', AddToCartPopup);
}
